import {mapGetters} from "vuex";

export default {
    name: 'course-fixed-module',
    data() {
        return {
            activeIndex: 0,
            show: false,
            showThreshold: 1000 // fallback поріг, буде перерахований динамічно
        }
    },
    computed: {
        ...mapGetters({
            currentItem: 'courses/currentItem',
        }),
        modules() {
            return this.currentItem.modules.data
        },
        romanNumber() {
            let lookup = {
                    M: 1000,
                    CM: 900,
                    D: 500,
                    CD: 400,
                    C: 100,
                    XC: 90,
                    L: 50,
                    XL: 40,
                    X: 10,
                    IX: 9,
                    V: 5,
                    IV: 4,
                    I: 1
                },
                romanNumber = '',
                index = this.activeIndex + 1,
                i;
            for (i in lookup) {
                while (index >= lookup[i]) {
                    romanNumber += i;
                    index -= lookup[i];
                }
            }
            return romanNumber;
        },
        totalTimeModule() {
            return this.calculationTimeModule(this.modules[this.activeIndex].duration);
        },
        completedLessons() {
            if (this.modules[this.activeIndex].userModule.data.hasOwnProperty('completedMaterials')) {
                return this.modules[this.activeIndex].userModule.data.completedMaterials
            }
            return 0
        },
        completedTimeModule() {
            if (this.modules[this.activeIndex].userModule.data.hasOwnProperty('completedMinutes')) {
                const duration = this.modules[this.activeIndex].userModule.data.completedMinutes;
                if (!duration) return 0;
                return this.calculationTimeModule(duration);
            }
            return 0
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.calculateThreshold()
            this.handleScroll()
            window.addEventListener('scroll', this.handleScroll)
            window.addEventListener('resize', this.onResize)
        })
    },
    methods: {
        calculateThreshold() {
            // Поріг = позиція першого модуля
            const firstModule = document.querySelector('.courses-dashboard_modules-item')
            if (firstModule) {
                const calculatedThreshold = firstModule.getBoundingClientRect().top + window.scrollY
                // Оновлюємо тільки якщо значення валідне (більше 100px)
                if (calculatedThreshold > 100) {
                    this.showThreshold = calculatedThreshold
                }
            } else {
                // Елементи ще не відрендерились - спробувати пізніше
                setTimeout(() => this.calculateThreshold(), 200)
            }
        },

        onResize() {
            // Перераховуємо поріг при зміні розміру вікна
            this.calculateThreshold()
        },

        handleScroll() {
            const elems = document.querySelectorAll('.courses-dashboard_modules-item')

            if (!elems.length) return

            // Показуємо панель коли доскролили до першого модуля
            this.show = window.scrollY >= this.showThreshold

            if (!this.show) return

            const headerOffset = 100 // offset для компенсації хедера
            const scrolled = window.scrollY + headerOffset

            elems.forEach((elem, index) => {
                const elemTop = elem.getBoundingClientRect().top + window.scrollY
                if (scrolled >= elemTop) {
                    this.activeIndex = index
                }
            })
        },
        formattedTimeLesson(time) {
            const hours = Math.floor(time / 60);
            const minutes = time % 60;
            return `${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}:00`
        },
        calculationTimeModule(duration) {
            const hours = Math.floor(duration / 60);
            const minutes = duration % 60;
            return `${hours} ${this.$t('longHour')}  ${minutes < 10 ? '0' + minutes : minutes}  ${this.$t('longMinutes')}`
        },
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll)
        window.removeEventListener('resize', this.onResize)
    }
}
